import { createTestId } from "@/core/utils/test-ids";

export const testIds = {
  rcStack: createTestId("report-builder", "rc-stack"),
};
